<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Product Types"
    local-storage-key="product_types"
    :state="productTypes"
    :read="productTypesStore.readProductTypes"
    :set="productTypesStore.setProductTypes"
    :delete="productTypesStore.deleteProductType"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <ProductTypeForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {ProductType} from '@/stores/userManagement/userManagement';

const productTypesStore = useProductTypesStore();
const {productTypes} = storeToRefs(productTypesStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof ProductType}>({
  'Product Type Name': 'name',
  'Product Type Description': 'description',
});
</script>
